import { useState } from 'react';
import type { SessionStorageValue } from '@/shared/lib/storage';
import { getSessionStorage, setSessionStorage } from '@/shared/lib/storage';

type OverrideValue = SessionStorageValue<'debug-prefectural-special-allocation-taxes-override'>;

/**
 * 都道府県特別交付税マッチングの利用可能状態オーバーライドを管理するフック
 * セッションストレージに状態を保存
 */
export const usePrefecturalSpecialAllocationTaxesOverride = () => {
  const [overrideValue, setOverrideValue] = useState<OverrideValue>(() =>
    getSessionStorage('debug-prefectural-special-allocation-taxes-override'),
  );

  const updateOverrideValue = (value: OverrideValue) => {
    setOverrideValue(value);
    setSessionStorage('debug-prefectural-special-allocation-taxes-override', value);
  };

  return {
    overrideValue,
    updateOverrideValue,
  };
};
